import { c as _c } from "react/compiler-runtime";
import { Fragment, useCallback } from "react";
import { MenuItem } from "@headlessui/react";
import clsx from "clsx";
import type { CompactMenuItem, CompactMenuProps } from "../types";
import { CompactMenuItemButton } from "./CompactMenuItemButton";
interface CompactMenuItemsPanelProps {
  readonly items: CompactMenuProps["items"];
  readonly activeItemId?: CompactMenuProps["activeItemId"];
  readonly onItemSelect?: CompactMenuProps["onItemSelect"];
  readonly close: () => void;
  readonly closeOnSelect: boolean;
  readonly itemClassName?: CompactMenuProps["itemClassName"];
  readonly activeItemClassName?: CompactMenuProps["activeItemClassName"];
  readonly inactiveItemClassName?: CompactMenuProps["inactiveItemClassName"];
  readonly focusItemClassName?: CompactMenuProps["focusItemClassName"];
  readonly itemsWrapperClassName?: CompactMenuProps["itemsWrapperClassName"];
  readonly unstyledItems?: boolean;
}
export function CompactMenuItemsPanel(t0) {
  const $ = _c(26);
  const {
    items,
    activeItemId,
    onItemSelect,
    close,
    closeOnSelect,
    itemClassName,
    activeItemClassName,
    inactiveItemClassName,
    focusItemClassName,
    itemsWrapperClassName,
    unstyledItems: t1
  } = t0;
  const unstyledItems = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== close || $[1] !== closeOnSelect || $[2] !== onItemSelect) {
    t2 = item => {
      if (item.disabled) {
        return;
      }
      if (closeOnSelect) {
        close();
      }
      item.onSelect?.();
      onItemSelect?.(item.id);
    };
    $[0] = close;
    $[1] = closeOnSelect;
    $[2] = onItemSelect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleItemClick = t2;
  let t3;
  if ($[4] !== itemsWrapperClassName) {
    t3 = clsx("tw-flex tw-flex-col", itemsWrapperClassName);
    $[4] = itemsWrapperClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== activeItemClassName || $[7] !== activeItemId || $[8] !== focusItemClassName || $[9] !== handleItemClick || $[10] !== inactiveItemClassName || $[11] !== itemClassName || $[12] !== items || $[13] !== unstyledItems) {
    let t5;
    if ($[15] !== activeItemClassName || $[16] !== activeItemId || $[17] !== focusItemClassName || $[18] !== handleItemClick || $[19] !== inactiveItemClassName || $[20] !== itemClassName || $[21] !== unstyledItems) {
      t5 = item_0 => {
        const isActive = item_0.active ?? activeItemId === item_0.id;
        return <MenuItem key={item_0.id} as={Fragment} disabled={item_0.disabled}>{t6 => {
            const {
              active
            } = t6;
            return <CompactMenuItemButton item={item_0} isActive={isActive} menuActive={active} onClick={() => handleItemClick(item_0)} itemClassName={itemClassName} activeItemClassName={activeItemClassName} inactiveItemClassName={inactiveItemClassName} focusItemClassName={focusItemClassName} unstyledItems={unstyledItems} />;
          }}</MenuItem>;
      };
      $[15] = activeItemClassName;
      $[16] = activeItemId;
      $[17] = focusItemClassName;
      $[18] = handleItemClick;
      $[19] = inactiveItemClassName;
      $[20] = itemClassName;
      $[21] = unstyledItems;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    t4 = items.map(t5);
    $[6] = activeItemClassName;
    $[7] = activeItemId;
    $[8] = focusItemClassName;
    $[9] = handleItemClick;
    $[10] = inactiveItemClassName;
    $[11] = itemClassName;
    $[12] = items;
    $[13] = unstyledItems;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[23] !== t3 || $[24] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}